import axios from "axios"; // 引入axios
import { Message } from "element-ui";
import store from "../store/index";
const baseURL = "";
const service = axios.create({
  baseURL: baseURL,
  timeout: 3000
});
window._axiosPromiseArr = [];
service.interceptors.request.use(
  config => {
    config.headers = {
      "Content-Type": "application/json",

      ...config.headers
    };
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel });
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.status == 0) {
      return response.data;
    } else {
      if (response.message) {
        alert(response.data.message);
      }

      return response.data;
    }
  },
  error => {
    switch (error.response && error.response.status) {
      case 500:
        Message.error("系统错误，请稍后再试");

      case 404:
        break;
    }
    store.state.isLoading = false;
    return Promise.reject(error);
  }
);
export default service;
